import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPatientTasks } from "app/services/transmission/patient";
import { BASE_URL } from "static/constants";

export const patientProfileTaskApi = createApi({
  reducerPath: "patientProfileTaskApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    fetchPatientTasks: query({
      queryFn: ({ patientId, page, pageSize, search }) => {
        return {
          data: getPatientTasks({ patientId, page, pageSize, search }),
        };
      },
    }),
  }),
});

export const { useFetchPatientTasksQuery } = patientProfileTaskApi;
